/* unplugin-vue-components disabled */import { render } from "./PBKYCFlow.vue?vue&type=template&id=4b24fcd6"
import script from "./PBKYCFlow.vue?vue&type=script&lang=js"
export * from "./PBKYCFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__